export const textFieldTrim = (text) => {
  return (
    (text &&
      text
        .replace(/\n/g, " ")
        .replace(/\r/g, " ")
        .replace(/\t/g, " ")
        .trim()) ||
    ""
  );
};

export const alphabet = (number) => {
  const baseChar = "A".charCodeAt(0);
  let letters = "";

  do {
    number -= 1;
    letters = String.fromCharCode(baseChar + (number % 26)) + letters;
    number = (number / 26) >> 0;
  } while (number > 0);

  return letters;
};

export const sortString = (a, b) => {
  return (
    a.location.split(" ")[0].length - b.location.split(" ")[0].length ||
    a.location.split(" ")[0].localeCompare(b.location.split(" ")[0]) ||
    Number(a.location.split(" ")[1]) - Number(b.location.split(" ")[1])
  );
};

export const convertDate = (dateString) => {
  const dateParts =
    dateString && dateString !== "" ? dateString.split(".") : null;
  if (!dateParts || dateParts.length !== 3) {
    return null;
  }

  const convertedDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
  return isValidDate(convertedDate) ? convertedDate : null;
};

const isValidDate = (date) => {
  return date instanceof Date && !isNaN(date);
};
